import { z } from 'zod';
import { getCardPositionDtoSchema } from '../getCardPositionDtoSchema';

export const cardsControllerCreate201Schema = z.array(
  z.lazy(() => getCardPositionDtoSchema),
);

export const cardsControllerCreate400Schema = z.union([
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['ForeignViolation']),
    details: z.object({ attributes: z.array(z.string()) }),
  }),
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['InvalidData']),
    details: z.object({
      location: z.enum(['path', 'query', 'body']),
      explanation: z.object({
        issues: z.array(
          z
            .object({
              code: z.enum([
                'invalid_type',
                'invalid_literal',
                'custom',
                'invalid_union',
                'invalid_union_discriminator',
                'invalid_enum_value',
                'unrecognized_keys',
                'invalid_arguments',
                'invalid_return_type',
                'invalid_date',
                'invalid_string',
                'too_small',
                'too_big',
                'invalid_intersection_types',
                'not_multiple_of',
                'not_finite',
              ]),
              path: z.array(z.union([z.string(), z.number()])),
              message: z.string(),
            })
            .catchall(z.unknown()),
        ),
      }),
    }),
  }),
]);

export const cardsControllerCreate401Schema = z.object({
  statusCode: z.enum(['401']),
  message: z.string(),
  type: z.enum(['Authentication']),
  details: z.object({
    reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
  }),
});

export const cardsControllerCreate403Schema = z.object({
  statusCode: z.enum(['403']),
  message: z.string(),
  type: z.enum(['Authorization']),
  details: z.object({ reason: z.enum(['InsufficientScope']) }),
});

export const cardsControllerCreateMutationRequestSchema = z.object({
  title: z.string().min(3).max(255),
  isActive: z.boolean().default(false).optional(),
  type: z.enum(['video', 'image', 'text', 'textAndImage', 'quiz', 'redirect']),
  courseId: z.string().uuid(),
  content: z.string().optional().nullable(),
  contentImage: z.string().optional().nullable(),
  contentDetails: z.string().optional().nullable(),
  position: z.number().int().min(1).optional(),
});

export const cardsControllerCreateMutationResponseSchema = z.array(
  z.lazy(() => getCardPositionDtoSchema),
);
